export enum ReviewTab {
  Reviews = 'reviews',
  Questions = 'questions'
}

export interface Product {
  id: string;
  title: string;
  volume?: string;
  imageUrl?: string;
  shortDescription?: string;
  url?: string;
}

export interface ReviewResponse {
  text: string;
  recommendedProduct?: Product;
}

export enum ReviewService {}

export interface Author {
  name: string;
}

export interface Review {
  id: string;
  rating: number;
  date: string;
  author: Author;
  pros: string | null;
  cons: string | null;
  comment: string | null;
  service?: ReviewService;
  source?: {
    type: ReviewService;
    url: string;
  };
  response?: ReviewResponse;
}

export interface Question {
  id: string;
  date: string;
  author: Author;
  question: string;
  response?: ReviewResponse;
}

export interface ReviewsData {
  totalCount: number;
  rating: number;
  items: Review[];
  ratingDetails: RatingDetails;
}

export type RatingFilter = '1' | '2' | '3' | '4' | '5';

export type RatingDetails = Record<RatingFilter, number>;

export enum TagFilter {
  WithPhoto = 'withPhoto'
}

export interface ReviewsFilter {
  selectedRating: RatingFilter | null;
  selectedTags: TagFilter[];
}

export enum SortType {
  Oldest = 'oldest',
  Newest = 'newest'
}
